/**
 * 【KYMW5002】画像情報詳細取得VO
 *
 * @export UseImageInfoModel
 * @class UseImageInfoModel
 */
export class UseImageInfoModel {
  // 設定画像情報
  /** 画像ID */
  public ImageId = String('');
  /** 画像名 */
  public ImageName = String('');
  /** 画像ファイル名 */
  public ImageFileName = String('');
  /** 開始受注コード */
  public StartOrderCode = String('');
  /** 表示順 */
  public ShowSeq = String('');
  /** 画像URL */
  public ImageURL = String('');
  /** 画像キャプション */
  public TextCaption = String('');
  /** 調理例掲載区分 */
  public CookingExPublish = String('');
}
